const GOOGLE_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";

let mapsLoader = null;

export function getGoogleMapsKey() {
  return GOOGLE_KEY;
}

export function hasCoords(loc) {
  return (
    loc &&
    Number.isFinite(Number(loc.latitude)) &&
    Number.isFinite(Number(loc.longitude))
  );
}

export function readStoredLocation() {
  try {
    const saved = JSON.parse(localStorage.getItem("user_location") || "null");
    if (hasCoords(saved)) return saved;
  } catch {
    // ignore
  }
  return null;
}

export function writeStoredLocation(location) {
  if (!hasCoords(location)) return;
  const payload = {
    latitude: Number(location.latitude),
    longitude: Number(location.longitude),
    timestamp: Date.now(),
  };
  localStorage.setItem("user_location", JSON.stringify(payload));
  return payload;
}

export function loadGoogleMaps() {
  if (!GOOGLE_KEY) {
    return Promise.reject(new Error("Google Maps API key is not configured"));
  }
  if (window.google?.maps) return Promise.resolve(window.google.maps);
  if (mapsLoader) return mapsLoader;

  mapsLoader = new Promise((resolve, reject) => {
    const existing = document.querySelector("script[data-google-maps]");
    if (existing) {
      existing.addEventListener("load", () => resolve(window.google.maps));
      existing.addEventListener("error", () => reject(new Error("Google Maps failed to load")));
      return;
    }
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(
      GOOGLE_KEY
    )}&v=weekly`;
    script.async = true;
    script.defer = true;
    script.dataset.googleMaps = "true";
    script.onload = () => resolve(window.google.maps);
    script.onerror = () => reject(new Error("Google Maps failed to load"));
    document.head.appendChild(script);
  });

  return mapsLoader;
}

function browserGps() {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      return reject({
        code: 0,
        userMessage: "Geolocation is not supported on this device",
      });
    }
    navigator.geolocation.getCurrentPosition(
      (pos) =>
        resolve({
          latitude: pos.coords.latitude,
          longitude: pos.coords.longitude,
          accuracy: pos.coords.accuracy,
          source: "GPS",
        }),
      (err) => {
        let userMessage = "Unable to fetch GPS location";
        if (err.code === 1) {
          userMessage =
            "Location permission denied. Click Allow when the browser asks, or enable Location in site settings.";
        } else if (err.code === 2) {
          userMessage = "Location is unavailable. Enable GPS and try again.";
        } else if (err.code === 3) {
          userMessage = "Location request timed out. Try again.";
        }
        reject({ code: err.code, message: err.message, userMessage });
      },
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 }
    );
  });
}

export async function detectLocation() {
  const coords = await browserGps();
  writeStoredLocation(coords);
  return {
    latitude: coords.latitude,
    longitude: coords.longitude,
  };
}
